import type { Project } from '../lib/types';
import { ArrowUpRight } from 'lucide-react';

export function ProjectCard({ project, featured = false }: { project: Project; featured?: boolean }) {
  return <article className={`project-card ${featured ? 'project-card--featured' : ''}`}><div className="project-art"><span>{project.category}</span></div><div className="project-info"><small>{project.category}</small><h2>{project.name}</h2><p>{project.description}</p>{project.url && <a href={project.url} target="_blank" rel="noreferrer">Visitar projeto <ArrowUpRight size={14} aria-hidden="true" /></a>}</div></article>;
}
